import { useState } from "react";
import { createPortal } from "react-dom";
import { Gift, Sparkles } from "lucide-react";

export default function ScratchCard({
    isScratch,
    onReveal,
    reward = 0,
    onStart,
}) {
    const [scratched, setScratched] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const handleClick = async () => {
        if (scratched) return;

        // get fresh reward instantly
        const generatedReward = onStart?.();

        setScratched(true);

        setTimeout(() => {
            setShowPopup(true);
        }, 700);

        // pass reward directly
        await onReveal?.(generatedReward);
    };

    return (
        <>
            {/* SCRATCH CARD */}
            <div
                onClick={handleClick}
                className="relative w-full h-[70px] rounded-2xl overflow-hidden cursor-pointer"
            >
                {/* REWARD BACKGROUND */}
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-300 flex flex-col items-center justify-center px-2">
                    <p className="text-[11px] font-semibold text-[#1a1a1a] flex items-center gap-1">
                        <Sparkles size={14} />
                        Reward Unlocked
                    </p>

                    <h3 className="text-[30px] font-black text-[#111] tracking-tight leading-none mt-1">
                        ₹{reward}
                    </h3>
                </div>

                {/* SCRATCH LAYER */}
                <div
                    className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ${scratched
                        ? "opacity-0 scale-125 rotate-2"
                        : "opacity-100 scale-100"
                        }`}
                    style={{
                        background:
                            "linear-gradient(135deg,#d1d5db,#9ca3af,#e5e7eb)",
                    }}
                >
                    <div className="text-center px-2">
                        <Gift
                            className="mx-auto mb-2 text-gray-700"
                            size={24}
                        />

                        <p className="text-[11px] font-extrabold tracking-[1px] text-gray-800 leading-tight">
                            TAP TO SCRATCH
                        </p>
                    </div>
                </div>
            </div>

            {/* FULL SCREEN POPUP */}
            {showPopup &&
                createPortal(
                    <div className="fixed inset-0 z-[99999] flex items-center justify-center px-5 bg-black/70 backdrop-blur-md animate-in fade-in duration-300">

                        {/* POPUP CARD */}
                        <div className="relative w-full max-w-[340px] overflow-hidden rounded-[32px] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.4)] animate-in zoom-in-95 duration-300">

                            {/* RED HEADER */}
                            <div
                                className="relative px-6 pt-10 pb-20 text-center overflow-hidden"
                                style={{
                                    background:
                                        "linear-gradient(135deg,#ED1C16 0%,#B30000 100%)",
                                }}
                            >
                                {/* GLOW */}
                                <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white/10 blur-3xl" />
                                <div className="absolute top-0 right-0 w-32 h-32 rounded-full bg-yellow-300/10 blur-2xl" />

                                {/* ICON */}
                                <div className="relative z-10">
                                    <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center mx-auto shadow-2xl mb-5 animate-bounce">
                                        <span className="text-5xl">🎉</span>
                                    </div>

                                    <p className="text-white/80 text-[12px] uppercase tracking-[4px] font-semibold">
                                        Congratulations
                                    </p>

                                    <h2 className="text-[46px] font-black text-white mt-2 leading-none drop-shadow-lg">
                                        ₹{reward}
                                    </h2>

                                    <p className="text-[14px] text-white/85 mt-3 leading-relaxed max-w-[220px] mx-auto">
                                        You have won an instant cashback reward.
                                    </p>
                                </div>
                            </div>

                            {/* WHITE CONTENT CARD */}
                            <div className="relative px-6 pb-6 -mt-12 z-20">
                                <div className="bg-white rounded-[24px] p-5 shadow-2xl border border-red-100 text-center">

                                    <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-3">
                                        <span className="text-2xl">💰</span>
                                    </div>

                                    <h3 className="text-[18px] font-bold text-[#111]">
                                        Cashback Added
                                    </h3>

                                    <p className="text-[13px] text-gray-500 mt-2 leading-relaxed">
                                        Your reward has been successfully credited to your wallet.
                                    </p>

                                    <button
                                        onClick={() => setShowPopup(false)}
                                        className="mt-5 w-full py-3.5 rounded-2xl text-white font-bold text-[15px] active:scale-[0.98] transition-all"
                                        style={{
                                            background:
                                                "linear-gradient(135deg,#ED1C16 0%,#B30000 100%)",
                                        }}
                                    >
                                        Continue 🚀
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
}